import { RedirectableFlow } from './redirectable-flow';
import { SignInFlow } from './sign-in-flow';

export type AppFlow = RedirectableFlow | SignInFlow;
